<template>
  <div 
    data-qa-id="loader-bar"
    :class="$style.loader"
    :style="style"
  ></div>
</template>